import { getHostFromUrl } from "./getHostFromUrl";

/**
 * Redirects the user to the /activation-portal page if the current domain matches the activation portal domain.
 * @param {string} portalActivationDomain - The activation portal domain.
 * @param {string} whiteLabelActivationDomain - The white label Domain, if available (overrides activationDomain if provided).
 */
export function redirectToActivationPortal(
  portalActivationDomain: string | undefined,
  whiteLabelActivationDomain: string | undefined
) {
  const activationDomain = whiteLabelActivationDomain ?? portalActivationDomain;

  if (activationDomain) {
    const currentBaseUrl = getHostFromUrl(window.location.origin);

    if (
      currentBaseUrl === activationDomain &&
      window.location.pathname !== "/activation-portal"
    ) {
      window.location.replace("/activation-portal");
    }
  }
}
